// Auto-generated-ish build stamp.
// Purpose: forcing a new asset bundle when you need to trigger a fresh Pages deploy.
export const BUILD_STAMP = "2026-02-20T13:03:58Z";
